import { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { isCurrentLocation } from "shared/utils/utils";

export interface NavigationItem {
  id: string;
  name: string;
  component?: ReactNode;
  href: string;
  items?: NavigationItem[];
}

export const useNavigationItemState = (item: NavigationItem) => {
  const location = useLocation();
  if (item.items?.some((item) => isCurrentLocation(location, item.href))) {
    return "child-active";
  }
  if (isCurrentLocation(location, item.href)) {
    return "active";
  }
  return "inactive";
};
